import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import AddRolesLayout from '../../Component/Layouts/AddRoles';


const mdTheme = createTheme();

function AddSubAdmin() {

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Custodian Performance"/>
        <AddRolesLayout/>
      </Box>
    </ThemeProvider>
  );
}

export default function index() {
  return <AddSubAdmin />
}